import { RequiredKeys } from '../types';

export const COLUMN_STATE_PROPS: ReadonlyArray<RequiredKeys<IColumnState>> = [
    'colId',
] as const;

export type IColumnState = {
    colId: string;
    hide?: boolean | null;
    width?: number;
    pinned?: boolean | undefined | 'left' | 'right' | null;
    rowGroup?: boolean | null;
    rowGroupIndex?: number | null;
    sort?: 'asc' | 'desc' | null;
    sortIndex?: number | null;
};

export type IFilterModel = Record<string, unknown>;
